import React from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { ReportType } from '../../pages/Reports/Reports';
import { useTranslation } from 'react-i18next';
import styles from './ReportTypeSelector.module.css';

interface ReportTypeSelectorProps {
  value: ReportType | null;
  onChange: (type: ReportType) => void;
}

const ReportTypeSelector: React.FC<ReportTypeSelectorProps> = ({ value, onChange }) => {
  const { t } = useTranslation();

  const reportTypes: { value: ReportType; label: string }[] = [
    { value: 'products', label: t('reports.types.products') },
    { value: 'clients', label: t('reports.types.clients') },
    { value: 'documents', label: t('reports.types.documents') },
    { value: 'stock', label: t('reports.types.stock') },
    { value: 'suppliers', label: t('reports.types.suppliers') },
    { value: 'users', label: t('reports.types.users') },
    { value: 'locations', label: t('reports.types.locations') },
  ];

  return (
    <Box className={styles.container}>

      <FormControl fullWidth className={styles.select} sx={{ mt: 2 }}>
        <InputLabel id="report-type-label">{t('reports.reportType')}</InputLabel>
        <Select
          labelId="report-type-label"
          value={value || ''}
          label={t('reports.reportType')}
          onChange={(e) => onChange(e.target.value as ReportType)}
          MenuProps={{
            PaperProps: {
              sx: {
                backgroundColor: '#2a2a2a',
                color: '#ffffff',
                '& .MuiMenuItem-root': {
                  color: '#ffffff',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  },
                  '&.Mui-selected': {
                    backgroundColor: 'rgba(143, 145, 143, 0.3)',
                    '&:hover': {
                      backgroundColor: 'rgba(143, 145, 143, 0.3)',
                    },
                  },
                },
              },
            },
          }}
        >
          {reportTypes.map((type) => (
            <MenuItem key={type.value} value={type.value}>
              {type.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default ReportTypeSelector;

